// CoreDNA renders multi-option checkbox groups (name="foo[]", inside a
// .checkbox-list) without a `required` attribute — unlike every other input
// type — so the browser happily submits the form and the "required" error only
// appears after a full server round trip. This module plugs those groups into
// native constraint validation: while no box in a required group is ticked, a
// custom validity message on the group's first checkbox blocks submission with
// the standard browser bubble, matching the behaviour of the other fields.
//
// Required-ness is detected via the `.element--required` wrapper the form
// templates (simple.html, competition-form.html, micro-form.html,
// competitions.html) place around required elements. Single checkboxes already
// carry a native `required` attribute and are left alone.

const GROUP_MESSAGE = 'Please tick at least one option.';

class FormCheckboxGroup {
	static #initialized = false;

	static initialize() {
		if (this.#initialized) return;
		this.#initialized = true;

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => this.#setup());
		} else {
			this.#setup();
		}
	}

	static #setup() {
		document.querySelectorAll('.element--required .checkbox-list').forEach(list => {
			const boxes = Array.from(list.querySelectorAll('input[type="checkbox"]'));
			if (!boxes.length) return;

			const update = () => {
				const anyChecked = boxes.some(box => box.checked);
				boxes[0].setCustomValidity(anyChecked ? '' : GROUP_MESSAGE);
			};

			boxes.forEach(box => box.addEventListener('change', update));
			update();
		});
	}
}

FormCheckboxGroup.initialize();

export default FormCheckboxGroup;